<template>
    <a-modal 
             :visible="isVisible"
             :closable="false"
             width="400px"
    >
        <template slot="footer">
            <a-button key="back" @click="handleCancel">
                Close
            </a-button>
        </template>
        <a-row type="flex" justify="start" class="icons-list">

            <a-popconfirm placement="top" ok-text="Yes" cancel-text="No" @confirm="handleReady" v-if="showNotify">
                <template slot="title">
                    <p>Is the order ready?</p>
                </template>
                <a-button icon="down-square" block shape="round">
                    Set Ready
                </a-button>
            </a-popconfirm>

            <a-button icon="down-square" block shape="round" @click="handleReady" v-else>
                Set Ready
            </a-button>

            <a-button icon="check" block shape="round" @click="handleDelivered">
                Set Delivered
            </a-button>
        
        </a-row>
    </a-modal>
</template>

<script>
export default {

    data() {
        return {
            isVisible : false,
            showNotify : false,
            
        }
    },
    methods : {
        notifyIfTooEarly() {

        },

        show(record) {
            console.log(record)
            this.isVisible = true;  
            this.showNotify = this.$store.getters['orderManager/canBeReady'](record.orderId);

        },  


        handleCancel() {
            this.reset();
        },

        handleReady() {
            this.$emit('setReadyEventClicked');
            console.log('handleReady:')
            this.reset();
            

        },

        handleDelivered() {

            this.$emit('setDeliveredEventClicked');
            this.reset();
            
        },

        reset() {
            console.log('reset is called')
            this.isVisible = false;
            this.showNotify = false;
        }
        
    }
}
</script>

<style scoped>
button {
    margin-top: 10px;
}
</style>